export const FAQS = [
  {
    q: "How Does Zenia Manage My Property Day To Day?",
    a: "Zenia takes care of pricing, listings, guest communication, cleaning coordination and ongoing performance so you don’t have to handle daily operations."
  },
  {
    q: "Where Will My Property Be Listed?",
    a: "Your property is listed across major booking platforms including Airbnb, Booking.com and Vrbo with everything managed through a single system."
  },
  {
    q: "How Is Pricing Decided?",
    a: "Pricing is adjusted continuously based on demand, seasonality, local trends and booking behaviour to maximise occupancy and revenue."
  },
  {
    q: "Will I Be Able To Track Performance?",
    a: "Yes, you will receive clear monthly updates covering revenue, occupancy and overall performance insights."
  },
  {
    q: "How Are Guest Conversations Handled?",
    a: "All guest communication including inquiries, check in support and issue resolution is handled by our team to ensure a smooth experience."
  },
  {
    q: "Who Handles Cleaning And Maintenance?",
    a: "We coordinate trusted cleaning and maintenance partners and ensure quality is maintained after every stay."
  },
  {
    q: "Do I Still Have Control Over My Property?",
    a: "You always remain in control. We handle execution while keeping you informed and aligned on key decisions."
  },
  {
    q: "How Long Does It Take To Get Started?",
    a: "Once your property details are reviewed, onboarding can begin within a few days depending on readiness."
  },
  {
    q: "Can You Manage Multiple Properties?",
    a: "Yes, we support both single properties and larger portfolios with centralized management and reporting."
  },
  {
    q: "Is This Suitable If I Am New To Hosting?",
    a: "Absolutely. We guide you through setup, positioning and best practices so you can start strong from day one."
  }
];